/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import File from "core/models/file";
import Ember from "ember";
import { STYLES } from "ui-kit/components/validated-field";
let FileUploadComponent = (_class = class FileUploadComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "errorStyles", STYLES["left-aligned-validation-error-message"]);
    /**
     * The maximum size of the file, in bytes.
     * Currently, it's 1Mb in test, 10 Mb otherwise
     */
    _defineProperty(this, "maxFileSize", Ember.testing ? 1024 : 10485760);
    /**
     * A flag to show error message about file size.
     */
    _initializerDefineProperty(this, "maxFileSizeReached", _descriptor2, this);
    /**
     * A flag indicating if a file is correctly uploaded (client-side).
     */
    _initializerDefineProperty(this, "fileIsUploaded", _descriptor3, this);
    /**
     * An array containing the names of each file selected to be uploaded
     */
    _initializerDefineProperty(this, "fileNames", _descriptor4, this);
    /**
     * The progress uploading the file in the browser
     */
    _initializerDefineProperty(this, "progress", _descriptor5, this);
    this.htmlInputId = guidFor(this);
  }
  /**
   * The upload action is called when the file input changes.
   */
  upload(event) {
    this.fileIsUploaded = false;
    const elementFiles = event.target.files;
    const file = elementFiles ? elementFiles[0] : null;
    if (!file) {
      /**
       * if the user clicked on "cancel", nothing changes
       */
      return;
    }
    this.maxFileSizeReached = false;
    const reader = new FileReader();
    if (file.size > this.maxFileSize) {
      this.maxFileSizeReached = true;
      reader.abort();
      return;
    }
    reader.readAsDataURL(file);
    reader.onload = () => {
      const fileAttachment = this.store.createRecord("file-attachment", {
        mimeType: reader.result?.toString().split(";")[0].split(":")[1],
        index: this.fileNames.length
      });
      const fileContent = this.store.createRecord("file-content", {
        data: reader.result?.toString().split(",")[1],
        fileAttachment
      });
      this.args.onSelected(new File(fileAttachment, fileContent));
    };

    /**
     * While the file is uploading, we update the progress bar.
     * As it's currently applying to client-side uploading,
     * it's quite fast. Perhaps, it gives some feedback to the user,
     * and it may be used in the future for a server-side upload.
     */
    reader.addEventListener("progress", event => {
      if (event.loaded && event.total) {
        this.progress = event.loaded / event.total * 100;
      }
    });

    /**
     * Once the file successfully uploaded, we
     * push its name in the fileNames array, set
     * the flag fileIsUploaded to true and call
     * the transition 2 seconds later
     */
    reader.onloadend = () => {
      this.fileIsUploaded = true;
      this.fileNames = [...this.fileNames, file.name];
      setTimeout(() => {
        this.progress = 0;
      }, 2000);
    };
  }

  /**
   * When a file is destroyed,
   * we removed its name from the fileNames
   * array, reset some fields and we call
   * the function passed as an arg.
   */
  destroyFile(index) {
    this.args.onDestroy(index);
    this.fileNames.splice(index, 1);
    this.fileNames = [...this.fileNames];
    this.progress = 0;
    document.getElementById(this.htmlInputId).value = "";
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "maxFileSizeReached", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fileIsUploaded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "fileNames", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "progress", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "upload", [action], Object.getOwnPropertyDescriptor(_class.prototype, "upload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyFile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyFile"), _class.prototype), _class);
export { FileUploadComponent as default };